export function getFriendlyFileSize(rawSize) {
  const fileSizesUnits = ['KB', 'MB', 'GB'];
  let i = 0;
  while (rawSize > 900) {
    rawSize /= 1024;
    i++;
  }
  return Math.round(rawSize * 100) / 100 + fileSizesUnits[i];
}
